import styled from "styled-components";

export const CardImgTitle = styled.div`
	padding: 3.75rem;
	background-color: rgb(0, 27, 72);
	color: #fff;
	display: flex;
	align-items: center;

	& h5 {
		margin-left: 1.25rem;
		font-size: 1rem;
		font-weight: 700;
		text-transform: uppercase;
	}
`